import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import ServicesSection from './components/ServicesSection';
import BlueprintSection from './components/BlueprintSection';
import ProjectMapSection from './components/ProjectMapSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="bg-cream-50">
      <HeroSection />
      <StatsBar />
      <ServicesSection />
      <BlueprintSection />
      <ProjectMapSection />
      <ContactSection />
    </div>
  );
}